import { useNavigate } from 'react-router-dom';
import { Button, Layout, Space, Typography } from 'antd';

export const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <Layout.Content
      style={{
        padding: 24,
        margin: 0,
        minHeight: 280,
        backgroundImage: `url(../assets/images/gettyimages-869509756-1920x1080.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'cover',
      }}
    >
      <div
        style={{
          margin: 'auto',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
          borderRadius: 10,
          paddingTop: 20,
          paddingRight: 50,
          paddingBottom: 30,
          paddingLeft: 50,
        }}
      >
        <Space direction="vertical">
          <div
            style={{
              fontSize: 90,
              lineHeight: 1,
            }}
          >
            SAAF - T3
          </div>
          <div style={{ marginLeft: 10 }}>
            <Typography style={{ fontSize: 18, color: 'white' }}>
              TSMC External Node - Legal Authorization Letter amendment approvals
            </Typography>
            <Space style={{ marginTop: 50 }}>
              <Button onClick={() => navigate('profiles/create')}>Submit for TSMC approval</Button>
              <Button onClick={() => navigate('approvals')}>Approvals</Button>
              <a href="https://wiki.ith.intel.com/x/Z2oRz" target="_blank" style={{ color: 'white' }} rel="noreferrer">
                Wiki
              </a>
            </Space>
          </div>
        </Space>
      </div>
    </Layout.Content>
  );
};
